import { ApiResponse, Service } from '@repo/core'
import {
  ConsolidatedPortfolioRequestParams,
  ConsolidatedPortfolioResponse,
} from '@repo/position-types'
import { AxiosRequestConfig } from 'axios'

export const getConsolidatedPortfolio: Service<
  ConsolidatedPortfolioRequestParams,
  ApiResponse<ConsolidatedPortfolioResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  return api.get<ApiResponse<ConsolidatedPortfolioResponse>>('/position/investments', {
    params,
    ...config,
    ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
  })
}
